//
//
//
//
//


import {createNamespacedHelpers} from "vuex";

const baseHelper = createNamespacedHelpers('base');

export default {
  name: 'mp-overlay',
  created() {

  },
  computed: {
    ...baseHelper.mapGetters([
      'getOverlay'
    ])
  }
}
